// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class AssertionError extends Error {
    /**
     * Assert a certain condition.
     *
     * @param condition The condition to assert.
     * @param msg A message, or function to retrieve one, for when the assertion fails.
     * @throws AssertionError When the `condition` is false.
     */
    static assert(condition, msg) {
        if (!condition) {
            throw new AssertionError(typeof msg === 'function' ? msg() : msg);
        }
    }
    /**
     * Assert that an Either is a right.
     *
     * @param value The value to assert for.
     * @param getMsg The function to get the assertion message.
     * @throws AssertionError When the `value` is a Left.
     */
    static assertIsRight(value, getMsg) {
        if (value.isLeft()) {
            const left = value.extract();
            throw new AssertionError(getMsg?.(left) ?? `Expected value to be a Right, got a Left with: ${String(left)}`);
        }
    }
    /** @inheritdoc */
    static assertInstance(cls, obj) {
        if (obj == null) {
            return (innerObj) => AssertionError.assertInstance(cls, innerObj);
        }
        if (obj instanceof cls) {
            return obj;
        }
        const objTyp = obj?.constructor?.name ?? typeof obj;
        throw new AssertionError(`Expected a value of type "${cls.name}" but got a "${objTyp}"`);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static assertNever(value, msg) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        throw new AssertionError(msg ?? `The value ${value} was never expected to exist`);
    }
    /* @__NO_SIDE_EFFECTS__ */
    /**
     * Assert that your argument is of a given type.
     *
     * You MUST set the template argument manually in this method.
     *
     * @param _ The argument to assert for.
     */
    static typeAssert(_) {
        // NOT EMPTY
    }
    /* @__NO_SIDE_EFFECTS__ */
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static typeEqual(_) {
        // NOT EMPTY
    }
}
